import React from 'react';

import classes from './GoogleCalendarModal.module.scss';

import UnderlinedLink from '../../UI/UnderlinedLink/UnderlinedLink';

const GoogleCalendarModal = (props) => {
    const getCalendarAppLink = () => {
        const userAgent = navigator.userAgent;

        if (/android/i.test(userAgent)) {
            return "https://play.google.com/store/apps/details?id=com.google.android.calendar";
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "https://apps.apple.com/app/google-calendar/id909319292";
        }
        return "https://calendar.google.com/";
    };

    return (
        <div className='GoogleCalendarModal_content_color'>
            <div className={`${classes.title} GoogleCalendarModal_highlight_color`}>Информация о Google календаре</div>
            <ul>
                <li>мы предоставляем календарь с расписанием, который полностью синхронизируется на основе наших
                    данных.
                </li>
                <li>после импорта календаря на вашу учетную запись вы будете иметь доступ к актуальной информации на
                    вашем телефоне в любом приложении, которое поддерживает синхронизацию с Google аккаунтом.
                </li>
            </ul>
            <div className={`${classes.title} GoogleCalendarModal_highlight_color`}>Импортировать себе календарь "{props.target}"</div>
            <ul>
                <li>{`по `}
                    <UnderlinedLink
                        href={`https://calendar.google.com/calendar/u/0/r?cid=${props.calendarId}`}
                        text="ссылке"
                        target="_blank" rel="noreferrer"/>.
                </li>
                <li>используя id календаря <span className={`${classes.highlight} GoogleCalendarModal_highlight_color`}>{props.calendarId}</span>.</li>
            </ul>
            <div className={`${classes.title} GoogleCalendarModal_highlight_color`}>Как использовать</div>
            <div>{`К примеру вы можете воспользоваться официальным приложением от `}
                <UnderlinedLink
                    href={getCalendarAppLink()}
                    text="Google"
                    target="_blank" rel="noreferrer"/>.
            </div>
            <div>{`Справочную информацию по календарям вы можете найти `}
                <UnderlinedLink
                    href="https://support.google.com/calendar/answer/6261951?hl=ru&ref_topic=3417927"
                    text="здесь"
                    target="_blank" rel="noreferrer"/>.
            </div>
        </div>
    )
};

export default GoogleCalendarModal;